<template>
  <div class="next-button">
    <AppButton type="link" size="xs" text="листайте" with-icon icon-position="right" @click="next">
      <template #right>
        <IconDefault name="arrow-right-long" size="s"></IconDefault>
      </template>
    </AppButton>
  </div>
  <swiper
    :modules="modules"
    :slides-per-view="1"
    :space-between="5"
    :loop="true"
    :initial-slide="0"
    :pagination="{ clickable: true }"
    @swiper="onSwiper"
  >
    <swiper-slide v-for="(item, index) in images" :key="index">
        <img class="swiper-image" :src="item.url" alt="-">
        <div class="swiper-text" v-html="item.title"></div>
    </swiper-slide>
  </swiper>
</template>
<script setup lang="ts">
import type { Props } from './model';
import { Swiper, SwiperSlide } from 'swiper/vue';
import {  Pagination } from 'swiper/modules';
import 'swiper/css';
import AppButton from "@components/AppButton/index.vue";
import IconDefault from "@components/AppIcon/index.vue";

defineOptions({
  name:'AppSlider'
})
const props = defineProps<Props>();
const modules = [Pagination];
const swiperInstance = ref(null);

const onSwiper = (swiper) => {
  swiperInstance.value = swiper;
};
const next = () => {
  swiperInstance.value.slideNext();
};
</script>
<style  lang="scss">
.next-button{
  padding: 0 var(--space-12);
  display: flex;
  justify-content: flex-end;
  margin-top: -5rem;
  @media screen and (max-width: 769px) {
    margin-top: unset;
  }
}
.swiper .swiper-pagination {
  position: absolute;
  text-align: center;
  transition: 300ms opacity;
  transform: translate3d(0, 0, 0);
  z-index: 10;
  top: var(--space-10);
  width: 100%;
  bottom: unset;
  .swiper-pagination-bullet{
    display: inline-block;
    width: 6px;
    height: 6px;
    border-radius: 50%;
    transition:all ease-in 0.5s;
    border: 1px solid transparent;
    box-sizing: border-box;
    &:not(:first-child){
      margin-left: var(--space-12);
    }
    &::before{
      content: '';
      width: 2px;
      height: 2px;
      border-radius: 50%;
      background: var(--color-primary);
      display: block;
      margin-top: 26%;
      margin-left: 27%;
    }
    &-active{
      border: 1px solid var(--color-primary);
    }
  }

}
 .swiper-image{
   height:32rem;
   width: 100%;
   object-fit: cover;
   object-position: center;
   border-radius: var(--border-radius-xxs);
 }
 .swiper-text{
    margin-top: var(--space-10);
    font-size: var(--font-size-12);
   line-height: var(--font-size-14);
     @media screen and (max-width: 769px) {
       padding-left: var(--space-20);
       font-size: var(--font-size-10);
     }
 }
</style>